<template>
    <div id="app">
        <vue-progress-bar></vue-progress-bar>
        <vue-snotify></vue-snotify>
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
// ANIMATION
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

.slide-fade-enter-active {
    transition: all 0.1s ease;
}
.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
    transform: translateX(-10px);
    opacity: 0;
}

.fadeHeight-enter-active,
.fadeHeight-leave-active {
    transition: all 0.2s;
    max-height: 230px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
    opacity: 0;
    max-height: 0px;
}

.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}

.ghost-patient {
    opacity: 0.5;
    .top-devir {
        background: $blue !important;
    }
}

.blink {
    animation: blink 1s linear infinite;
}

@keyframes blink {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}

.gradientback {
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 40px;
    background: -moz-linear-gradient(
        top,
        rgba(137, 255, 241, 0) 0%,
        #f5f5f5 100%
    ); /* FF3.6+ */
    background: -webkit-gradient(
        linear,
        left top,
        left bottom,
        color-stop(0%, rgba(137, 255, 241, 0)),
        color-stop(100%, #f5f5f5)
    ); /* Chrome,Safari4+ */
    background: -webkit-linear-gradient(
        top,
        rgba(137, 255, 241, 0) 0%,
        #f5f5f5 100%
    ); /* Chrome10+,Safari5.1+ */
    background: -o-linear-gradient(
        top,
        rgba(137, 255, 241, 0) 0%,
        #f5f5f5 100%
    ); /* Opera 11.10+ */
    background: -ms-linear-gradient(
        top,
        rgba(137, 255, 241, 0) 0%,
        #f5f5f5 100%
    ); /* IE10+ */
    background: linear-gradient(
        to bottom,
        rgba(137, 255, 241, 0) 0%,
        #f5f5f5 100%
    ); /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#0089fff1', endColorstr='#f5f5f5',GradientType=0 ); /* IE6-9 */
}

// GLOBAL CSS
body {
    font-family: "Baloo Paaji 2", "Helvetica Neue", "Tahoma", Geneva, Verdana,
        sans-serif;
    background: $sidebar;
    font-size: 13px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

hr {
    border-top: 1px solid $divider;
}

.divider {
    margin: 5px 2px;
    height: 1px;
    background-color: $gray-200;
}

a {
    text-decoration: none;
    cursor: pointer;
}

.bold {
    font-weight: 700;
}

.ws-preline {
    white-space: pre-line;
}

.fl {
    float: left;
}

.fr {
    float: right;
}

.tr {
    text-align: right;
}

.ps {
    height: calc(100vh - 78px);
}

.bold {
    font-weight: bold;
}

.clear {
    clear: both;
}

#page-body {
    padding: 0 0;
    margin-left: 230px;
    min-height: 100vh;
    z-index: 80;
    position: relative;
    background-color: $background;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
}

#header {
    background: $primary;
    height: 45px;
    width: calc(100% - 250px);
    position: fixed;
    z-index: 80;
    display: flex;
    flex-direction: row;
    margin-right: 250px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
        0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    &.short {
        width: calc(100% - 550px);
    }
    .name {
        padding: 0 5px;
        font-size: 17px;
        color: white;
        line-height: 44px;
        svg {
            width: 50px;
        }
    }
}

.h-bar {
    background: $sidebarLight;
    background-image: url("./assets/panel_bg.png"),
        linear-gradient(to top left, black, $primary);
    background-repeat: repeat;
    height: 68px;
    width: calc(100% - 230px);
    position: fixed;
    margin-top: 0;
    z-index: 80;
    display: flex;
    flex-direction: column;
    &.short {
        width: calc(100% - 510px);
    }
    div.sex {
        position: absolute;
        margin: 0;
        top: 10px;
        left: 5px;
        border-radius: 5px;
        right: 0;
        width: 35px;
        height: 35px;
        span {
            border-radius: 17px;
            display: block;
        }
        svg {
            color: white;
            padding: 5px;
            width: 35px;
            height: 35px;
        }
    }
    .name {
        margin-top: 10px;
        min-width: 350px;
        padding: 0 0 0 10px;
        font-size: 15px;
        font-weight: 700;
        color: white;
        line-height: 20px;
        a {
            padding: 0 5px;
        }
    }
    .details {
        min-width: 350px;
        padding: 0 0 0 50px;
        font-size: 14px;
        line-height: 20px;
        color: white;
    }
    div.kan-grubu {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 70px;
        background-color: rgba(255, 255, 255, 0.08);
        border-radius: 5px;
        display: inline-block;
        text-align: center;
        width: 120px;
        span {
            color: white;
            transition: margin 0.6s, opacity 1s;
        }
        &:hover {
            span.anne {
                opacity: 1;
            }
            span.bebek {
                margin-top: 4px;
                margin-bottom: -1px;
            }
        }
        span.anne {
            flex: 1 1 auto;
            font-size: 13px;
            display: block;
            background-color: rgba(255, 255, 255, 0.08);
            line-height: 22px;
            opacity: 0;
        }
        span.bebek {
            flex: 1 1 auto;
            font-size: 20px;
            font-weight: 500;
            display: block;
            line-height: 20px;
            margin-top: 0px;
            margin-bottom: 3px;
        }
        span.coombs {
            display: block;
            font-size: 12px;
            flex: 1 1 auto;
            line-height: 23px;
        }
    }
    .completed {
        position: absolute;
        font-size: 18px;
        right: 5px;
        .percent {
            margin-top: -2px;
        }
    }
}

.menu-bar {
    background-color: $gray-100;
    border-bottom: 1px solid $gray-300;
    line-height: 20px;
    padding: 5px;
    width: calc(100% - 230px);
    position: fixed;
    z-index: 80;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    &.not-fixed {
        position: relative;
        width: 100%;
    }
    span.text {
        line-height: 30px;
        padding: 0 5px;
    }
    input[type="date"],
    input[type="datetime-local"] {
        padding: 0.3em 0.5em;
    }
}

#content {
    padding-top: 0;
}

#rightbar {
    background-color: $rightSidebar;
    position: fixed;
    top: 0;
    right: 0;
    width: 280px;
    height: 100vh;
    z-index: 1;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
    -webkit-box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
    .list-header {
        color: $text;
        //border-bottom: 1px solid lighten($orange, 15) !important;
        span,
        a {
            display: inline-block;
            font-size: 14px;
            line-height: 44px;
            margin: 0 10px;
            font-weight: 500;
        }
        a {
            float: right;
            padding: 0 !important;
        }
    }
}

.row {
    display: flex;
    flex-wrap: wrap;
}

.col {
    flex: 1 0 0;
}

ul.patients {
    list-style-type: none;
    margin-bottom: 1px;
    div.yeri {
        position: relative;
        background-color: lighten($orange, 5);
        border-bottom: 1px solid $orange;
        font-size: 11px;
        padding: 5px;
        font-weight: 700;
        color: black;
        line-height: 15px;
        span {
            position: absolute;
            right: 2px;
            top: 2px;
            background-color: $orange-light;
            color: $blue;
            font-size: 12px;
            border-radius: 3px;
            width: 22px;
            height: 22px;
            padding: 3px 1px;
            text-align: center;
        }
    }
    li {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
        margin-top: 1px;
        border-left: 3px solid $orange;
        display: flex;
        cursor: pointer;
        .col-gun {
            flex: 0 0 32px;
            vertical-align: top;
            width: 32px;
            text-align: center;
            font-size: 10px;
            padding: 5px 1px;
            background-color: lighten($orange, 10);
            .gun {
                font-weight: 500;
                font-size: 12px;
                margin-bottom: 2px;
            }
        }
        .col-name {
            flex: 1 1 auto;
            width: calc(100% - 32px);
            font-weight: 700;
            padding: 5px 3px;
            .tanilar {
                font-weight: 400;
                font-size: 10px !important;
            }
        }
        &.router-link-active,
        &.router-link-active .col-gun {
            color: black !important;
            background-color: transparentize($primary, 0.8) !important;
        }
        &:hover,
        &:hover .col-gun {
            background-color: transparentize($primary, 0.9) !important;
        }
        &:nth-child(odd) {
            background-color: lighten($orange, 15);
        }
        &:nth-child(even) {
            background: lighten($orange, 20);
        }
        &.unfinished {
            border-color: $red;
        }
        &.finished {
            border-color: $green;
        }
    }
    .empty {
        background-color: lighten($orange, 15) !important;
    }
}

ul.khd {
    list-style-type: none;
    margin-bottom: 1px;
    div.yeri {
        background-color: lighten($orange, 5);
        border-bottom: 1px solid $orange;
        font-size: 11px;
        padding: 5px;
        color: black;
        line-height: 15px;
        font-weight: 700;
        position: relative;
        span {
            position: absolute;
            right: 2px;
            top: 2px;
            background-color: $orange-light;
            color: $blue;
            font-size: 12px;
            border-radius: 3px;
            width: 22px;
            height: 22px;
            padding: 3px 1px;
            text-align: center;
        }
    }
    li {
        &:first-child {
            border-top: 1px solid lighten($red, 30);
        }
        border-collapse: collapse;
        font-size: 12px;
        border-bottom: 1px solid lighten($red, 30);
        background-color: lighten($red, 40);
        display: flex;
        .warning {
            padding: 10px;
            svg {
                color: $red;
            }
        }
        .col-gun {
            flex: 0 0 40px;
            vertical-align: top;
            width: 40px;
            text-align: center;
            font-size: 10px;
            border-radius: 10px;
            padding: 15px 1px;
            .gun {
                font-weight: 500;
                font-size: 12px;
                margin-bottom: 2px;
            }
        }
        .col-name {
            flex: 1 1 auto;
            width: calc(100% - 40px);
            padding: 5px 3px;
            .name {
                font-weight: 700;
                line-height: 17px;
            }
            .detail {
                display: block;
                font-weight: 400;
                line-height: 15px;
                font-size: 10px !important;
            }
        }
    }
}

.patients2 {
    .list-header {
        color: $text;
        //border-bottom: 1px solid lighten($orange, 15) !important;
        span,
        a {
            display: inline-block;
            font-size: 14px;
            line-height: 44px;
            margin: 0 10px;
            font-weight: 500;
        }
        a {
            float: right;
            padding: 0 !important;
        }
    }
    table {
        width: 100%;
        border-collapse: collapse;
        border-radius: 5px;
        font-size: 12px;
        tr.selected {
            td {
                color: black !important;
                background-color: transparentize($primary, 0.7);
            }
        }
        table tr {
            border-left: 3px solid $orange;
        }
        tr td {
            cursor: pointer;

            .tanilar {
                font-size: 10px !important;
            }
        }
        tr:hover td {
            background-color: transparentize($primary, 0.8);
        }
        tr.empty th {
            height: 84px;
            background-color: lighten($orange, 15) !important;
            border: 0 !important;
        }
        th,
        td {
            text-align: left;
            padding: 5px;
            color: #000;
        }
        tr:nth-child(odd) {
            background-color: lighten($orange, 15);
        }
        tr:nth-child(even) {
            background: lighten($orange, 20);
        }
        th {
            background-color: lighten($orange, 5);
            border-bottom: 1px solid $orange;
            font-size: 11px;
        }
        .unfinished {
            border-color: $red;
        }
        .finished {
            border-color: $green;
        }
    }
}

.large-empty {
    text-align: center;
    padding: 22px 0;
    font-size: 16px;
    width: 100%;
    svg {
        padding: 0 4px;
        color: #777;
        vertical-align: middle;
        display: inline-block;
    }
    span {
        display: inline-block;
        padding: 0 4px;
        color: #777;
    }
}

.small-empty {
    text-align: center;
    padding: 30px 0;
    font-size: 14px;
    width: 100%;
    svg {
        display: inline-block;
        padding: 0 4px;
        color: #777;
        vertical-align: middle;
    }
    span {
        display: inline-block;
        padding: 0 4px;
        color: #777;
    }
}

div.tabs {
    margin: 1px 15px;
    ul {
        display: flex;
        list-style: none;
        align-items: flex-end;
        margin-top: 5px;
        li {
            margin-right: 3px;
            background-color: $gray-200;
            padding: 4px 8px;
            border: 1px solid $alphaDivider;

            border-top-left-radius: 5px;
            border-top-right-radius: 5px;

            &.active {
                position: relative;
                bottom: 0;
                padding: 8px 10px;
                background-color: white;
                border: 0;
                border-top: 2px solid $primary;
                color: $blue;
                font-weight: 700;
                box-shadow: 0 -3px 1px -3px rgba(0, 0, 0, 0.2),
                    0 -2px 2px 0 rgba(0, 0, 0, 0.14),
                    0 -2px 5px 0 rgba(0, 0, 0, 0.12);
            }
            &:hover {
                cursor: pointer;
                background-color: white;
                border-top: 2px solid $blue;
            }
        }
    }
    .content {
        border-top: 0 !important;
    }
}

div.patient-tabs {
    border-bottom: 1px solid $alphaDivider;
    ul {
        display: flex;
        list-style: none;
        align-items: flex-end;
        margin-top: 5px;
        li {
            flex: 1 1 50%;
            background-color: $gray-200;
            padding: 4px 8px;
            border-top: 1px solid $alphaDivider;
            border-bottom: 0;
            text-align: center;

            &.active {
                position: relative;
                bottom: 0;
                padding: 8px 10px;
                background-color: white;
                border: 0;
                border-top: 2px solid $primary;
                color: $blue;
                font-weight: 700;
                box-shadow: 0 -3px 1px -3px rgba(0, 0, 0, 0.2),
                    0 -2px 2px 0 rgba(0, 0, 0, 0.14),
                    0 -2px 5px 0 rgba(0, 0, 0, 0.12);
            }
            &:hover {
                cursor: pointer;
                background-color: white;
                border-top: 2px solid $blue;
            }
        }
    }
    .content {
        border-top: 0 !important;
    }
}

ul.tedavi-tabs {
    display: flex;
    list-style: none;
    align-items: flex-end;
    margin-bottom: 5px;
    border-bottom: 1px solid $gray-200;
    background-color: $gray-100;
    li {
        padding: 8px;
        margin: 5px;
        flex: 1 1 33.3%;
        text-align: center;
        border-radius: 5px;
        &.active {
            position: relative;
            bottom: 0;
            padding: 8px;
            background-color: $gray-400;
            font-weight: 700;
        }
        &:hover {
            cursor: pointer;
            background-color: $gray-200;
        }
    }
}

.y-grafik {
    display: flex;
    flex-direction: row;
    ul.grafik-tabs {
        display: flex;
        list-style: none;
        flex-direction: column;
        align-items: flex-end;
        border-right: 1px solid $gray-200;
        background-color: $gray-100;
        li {
            padding: 8px;
            margin: 5px 5px 0 5px;
            flex: 0 0 30px;
            width: 250px;
            border-radius: 5px;
            &.active {
                position: relative;
                bottom: 0;
                padding: 8px;
                background-color: $gray-400;
                font-weight: 700;
            }
            &:hover {
                cursor: pointer;
                background-color: $gray-200;
            }
        }
    }
    .tab-content {
        img {
            width: 100%;
            padding: 50px;
            height: 100%;
        }
    }
}

.tab-content {
    width: 100%;
    display: inherit;
    flex: inherit;
    flex-wrap: inherit;
    align-items: stretch;
}

.card-col {
    flex: 1 0 0 !important;
}

.card-50 {
    flex: 1 0 46% !important;
}

.card-40 {
    flex: 1 0 36% !important;
}

.card-60 {
    flex: 1 0 56% !important;
}

.card-flex {
    display: flex !important;
    flex-direction: column;
}

.card {
    background-color: white;
    display: block;
    min-width: 250px;
    min-height: 100px;
    flex: 1 1 100%;
    margin: 15px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
        0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    .header {
        background-image: url("./assets/panel_bg.png");
        background-color: $primary;
        color: white;
        line-height: 40px;
        padding: 0 10px;
        border-bottom: 1px solid $alphaDivider;
        font-size: 14px;
        font-weight: 500;
        position: relative;
        a.header-btn {
            position: absolute;
            right: 5px;
            top: 5px;
            bottom: 5px;
            line-height: 30px;
            margin: 0;
            padding: 0 14px;
        }
    }
    .topbar {
        background-color: $background;
        justify-content: flex-end;
        border-bottom: 1px solid $gray-300;
        display: flex;
        padding: 5px 0;
    }
    .count {
        font-family: "Roboto Slab", Tahoma, Geneva, Verdana, sans-serif;
        font-size: 72px;
        text-align: center;
        font-weight: 700;
        line-height: 110px;
    }
    .footer {
        border-top: 1px solid rgba(0, 0, 0, 0.12);
        width: 100%;
        text-transform: uppercase;
        text-align: center;
        line-height: 40px;
        font-size: 12px;
        font-weight: 700;
    }
    .editing-form {
        background-color: $gray-100;
        padding: 10px;
    }
}

// FORMS

form.multi-col {
    display: flex;
    flex-direction: row;
    .col {
        flex: 1 1 50%;
    }
}

.labeledit {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 3px 0;
    padding: 0 3px;

    label {
        padding: 6px;
        flex: 1 0 40%;
        font-weight: 500;
    }
    input,
    select,
    span,
    textarea,
    .toggle-group {
        flex: 1 0 60%;
    }
    &.vertical {
        flex-direction: column;
        align-items: flex-start;
        input,
        select,
        span,
        textarea,
        .toggle-group {
            flex: 1 1 100%;
            width: 100%;
        }
    }
}

input[type="text"],
input[type="password"],
input[type="date"],
input[type="datetime-local"],
input[type="number"],
input[type="search"],
select {
    outline: 0;
    padding: 0.5em;
    -webkit-transition: all 0.5s ease;
    background: white;
    font-family: Muli, Tahoma, Geneva, Verdana, sans-serif;
    font-size: 12px !important;
    min-height: 1.4em;
    -ms-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid $alphaDivider;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    &:focus,
    &:hover {
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
    &:required {
        border-left: 3px solid $red;
        background-color: $required;
    }
    &:required:valid {
        border-left: 3px solid $green;
        background-color: white;
    }
}

.c-input {
    background-color: $input !important;
}

.multi-toggle-group {
    display: flex;
    align-items: flex-start;
    > * {
        margin: 0 5px;
    }
    > :first-child {
        margin-left: 0;
    }
    > :last-child {
        margin-right: 0;
    }
    .toggle-group {
        flex: 1 1 auto;
    }
}

.toggle-group {
    display: flex;
    border: 1px solid $alphaDivider;
    background-color: white;
    border-radius: 0.25rem;
    flex-wrap: wrap;
    flex-direction: row;
    input[type="radio"]:required:invalid + span {
        background-color: $required;
        &:hover {
            background-color: darken($required, 3);
        }
    }
    label {
        padding: 0 !important;
        display: flex;
        flex: 1 1 auto;
        span {
            width: 100%;
            padding: 5px;
            font-size: 12px;
            text-align: center;
            background-color: white;
            cursor: pointer;
            &:hover {
                background-color: transparentize($blue, 0.8);
            }
        }
        &:first-child > span {
            border-top-left-radius: 0.25rem;
            border-bottom-left-radius: 0.25rem;
        }
        &:last-child > span {
            border-top-right-radius: 0.25rem;
            border-bottom-right-radius: 0.25rem;
        }
    }
    .modern:checked + span {
        background-color: $blue !important;
        color: white;
    }
    &.vertical {
        label {
            flex: 1 1 100%;
            &:first-child > span {
                border-radius: 0;
                border-top-left-radius: 0.25rem;
                border-top-right-radius: 0.25rem;
            }
            &:last-child > span {
                border-radius: 0;
                border-bottom-left-radius: 0.25rem;
                border-bottom-right-radius: 0.25rem;
            }
        }
    }
}

.multi-input {
    display: flex;
    width: 100%;
    input,
    select {
        flex: 1 0 49%;
        width: 100%;
    }
    .space {
        flex: 1 0 2%;
    }
}

[type="checkbox"]:checked,
[type="checkbox"]:not(:checked),
[type="radio"]:checked,
[type="radio"]:not(:checked) {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none;
}

textarea {
    border: 1px solid $alphaDivider;
    outline: 0;
    width: 100%;
    padding: 0.3em;
    font-size: 12px !important;
    line-height: 18px !important;
    resize: vertical;
    min-height: 1.4em;
    background-color: white;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    &:focus,
    &:hover {
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
}

button {
    border: 0;
    outline: 0;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    color: #fff;
    padding: 8px !important;
}

.btn {
    padding: 5px;
    margin: 0 5px;
    font-weight: 700;
    transition: all 0.2s ease;
    display: inline-block;
}

.date-bar {
    background-image: url("./assets/panel_bg.png");
    line-height: 40px;
    border-bottom: 1px solid $alphaDivider;
    height: 40px;
    display: flex;
    text-align: center;
    color: white;
    background-color: $gray-200;
    a {
        flex: 1 1 10%;
        color: $gray-300;
        svg {
            margin: 7px 5px;
        }
        &:hover {
            background-color: rgba(255, 255, 255, 0.1);
            color: white;
        }
    }
    label {
        flex: 1 1 80%;
        font-size: 16px;
        font-weight: 500;
    }
}

.seyir-bar {
    text-align: right;
    padding: 5px;
    background-color: $gray-100;
    border-bottom: 1px solid $gray-200;
}

.btn-rightbar {
    position: absolute;
    display: none;
    top: 0;
    color: black;
    left: 0;
    z-index: 80;
    background: $orange;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    a {
        display: block;
        padding: 10px 10px;
        width: 40px;
    }
}

.modal-overlay {
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
    .modal-box {
        width: 80%;
        &.medium {
            width: 60%;
        }
        &.small {
            width: 40%;
        }
        margin: 3% auto;
        background-color: $gray-100;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2),
            0 4px 20px 0 rgba(0, 0, 0, 0.19);
        form {
            padding: 10px;
        }
        h3 {
            padding: 10px;
            color: black;
            border-bottom: 1px solid $alphaDivider;
            background-color: $gray-200;
        }
        .close {
            transition: all 0.2s ease;
            color: white;
            float: right;
            font-size: 24px;
            font-weight: bold;
            background-color: $primary;
            padding: 0 7px 2px 7px;
            margin: 4px;
        }
        .close:hover,
        .close:focus {
            background-color: $red;
            text-decoration: none;
            cursor: pointer;
        }
        .button-bar {
            border-top: 1px solid $alphaDivider;
            background-color: white;
            padding: 8px 3px;
        }
    }
}

@media (max-width: 1280px) {
    html {
        text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
    }
    .no-patient {
        padding-right: 0 !important;
    }
    .no-mobile {
        display: none;
    }
    #page-body {
        margin: 45px 0 0 0;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
    }
    #header,
    #header.short {
        width: 100%;
    }
    .h-bar,
    .h-bar.short {
        width: 100%;
    }
    .large-empty {
        font-size: 14px;
        padding: 2px 0;
    }
    .small-empty {
        font-size: 12px;
        padding: 5px 0;
    }
    .widget-layout {
        flex-flow: column wrap !important;
        flex: 1 1 100% !important;
        flex-direction: row !important;
        .widget {
            flex: 1 1 50% !important;
            max-width: 100%;
        }
        .doclist {
            flex: 1 1 100% !important;
            max-width: 100% !important;
        }
        .activity {
            flex: 1 1 100% !important;
            max-width: 100% !important;
        }
    }

    .btn-rightbar {
        display: block !important;
    }
    .col {
        flex: 1 1 100%;
    }
    .menu-bar {
        width: 100%;
    }
    .modal-overlay {
        padding: 0;
        .modal-box {
            margin: 15% auto;
            width: 85% !important;
        }
    }
    .yatis-content {
        flex-direction: column;
    }
    .card-50 {
        flex: 1 1 100% !important;
    }

    #rightbar {
        .ps {
            height: calc(70vh - 78px);
        }
        position: fixed;
        z-index: 200;
        overflow: hidden;
        margin: 0 auto;
        width: 91%;
        left: 0;
        transition: all 0.6s ease;
        height: 70vh;
        &.opened {
            top: auto;
            bottom: 5px;
        }
        &.closed {
            top: auto;
            bottom: 5px;
            height: 45px;
        }
    }
}
</style>
